module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_vm._l((_vm.categorias), function(categoria, index) {
    return _c('div', {
      staticClass: "row center-block"
    }, [_c('box', {
      attrs: {
        "title": categoria.nome
      }
    }, [_c('div', {
      attrs: {
        "slot": "icon"
      },
      on: {
        "click": function($event) {
          return _vm.ajustarCollapse(index)
        }
      },
      slot: "icon"
    }, [_c('a', {
      attrs: {
        "data-toggle": "collapse",
        "href": '#collapse' + index,
        "role": "button",
        "aria-expanded": "false",
        "aria-controls": "collapseExample"
      }
    }, [_c('i', {
      staticClass: "fa fa-plus",
      staticStyle: {
        "padding-right": "10px"
      },
      attrs: {
        "aria-hidden": "true"
      }
    })])]), _vm._v(" "), _c('div', {
      attrs: {
        "slot": "body"
      },
      slot: "body"
    }, [_c('div', {
      staticClass: "dataTables_wrapper form-inline dt-bootstrap collapse",
      attrs: {
        "id": 'collapse' + index
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-12"
    }, [_c('draggable', {
      staticClass: "list-group",
      attrs: {
        "element": "ul",
        "options": _vm.dragOptions,
        "move": _vm.onMove
      },
      on: {
        "start": function($event) {
          _vm.isDragging = true
        },
        "end": function($event) {
          _vm.isDragging = false
        }
      },
      model: {
        value: (_vm.categorias[index].OrdemProdutos),
        callback: function($$v) {
          _vm.$set(_vm.categorias[index], "OrdemProdutos", $$v)
        },
        expression: "categorias[index].OrdemProdutos"
      }
    }, _vm._l((categoria.OrdemProdutos), function(element, i) {
      return _c('li', {
        key: element.order,
        staticClass: "list-group-item"
      }, [_vm._v("\n                          " + _vm._s(element.nome) + "\n                          "), _c('span', {
        staticClass: "badge"
      }, [_vm._v(_vm._s(i))])])
    }), 0)], 1)])])])])], 1)
  }), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "to": "/produtos"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger"
  }, [_vm._v("Cancelar")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.gravarOrdem
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }, [_vm._v("  Gravar")])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-715f09e9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/OrderProduto.vue
// module id = 1265
// module chunks = 1